import type { Option } from '@comparit/core';
import { Gebaeudetyp } from '../../../interfaces';

/** A Gebäudetyp card: the usual Option plus the `svgIcon` name the tile renders. */
export interface GebaeudetypOption extends Option<Gebaeudetyp> {
  icon: string;
}

export const gebaeudetypOptions: GebaeudetypOption[] = [
  {
    label: 'Einfamilienhaus',
    value: Gebaeudetyp.Einfamilienhaus,
    icon: 'cp-einfamilienhaus',
  },
  {
    label: 'Zweifamilienhaus',
    value: Gebaeudetyp.Zweifamilienhaus,
    icon: 'cp-zweifamilienhaus',
  },
  {
    label: 'Doppelhaushälfte',
    value: Gebaeudetyp.Doppelhaushaelfte,
    icon: 'cp-doppelhaushaelfte',
  },
  {
    label: 'Reihenhaus',
    value: Gebaeudetyp.Reihenhaus,
    icon: 'cp-reihenhaus',
  },
  {
    label: 'Mehrfamilienhaus',
    value: Gebaeudetyp.Mehrfamilienhaus,
    icon: 'cp-mehrfamilienhaus',
  },
];
